import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import TableAssignments from "./TableAssignments";
import { useLanguage } from "../../../../context/LanguageContext";
import { BaseUrlApi, ErrorMessage } from "../../../../lib/api";
import axios from "axios";
import { toast } from "sonner";
import DrawerAddHomeWork from "../../Lesson/Tabs/HomeWork/DrawerAddHomeWork";
import { SubLessonData } from "../../../../lib/languages";
import { useAuth } from "../../../../context/AuthContext";

export default function TeacherAssignments() {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  const { user } = useAuth();
  const isTeacher = user?.role === "teacher";

  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);

  const ApiUrl = isTeacher ? `teacher/assignments` : `student/assignments`;

  const fetchAssignments = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/${ApiUrl}`);
      setAssignments(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") toast("Error", { description: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchAssignments();
  }, []);

  return (
    <div className="space-y-8" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="flex items-center gap-2 justify-between flex-wrap">
        <h1 className="text-2xl font-bold">{t.assignmentsTitle}</h1>
        {isTeacher && (
          <DrawerAddHomeWork
            fetchAssignments={fetchAssignments}
            isTeacher={true}
          />
        )}
      </div>

      {!loading ? (
        <TableAssignments
          data={assignments}
          fetchAssignments={fetchAssignments}
          isTeacher={isTeacher}
        />
      ) : (
        <div className="h-40 w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
}
